import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { primaryShadow } from '@design-system/theme';
const getPanelWidth = (width = 'large') => width === 'large' ? '800px' : '600px';
export const Grid = styled.div `
  /* Sizing */
  height: 100vh;

  /* Layout */
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    'header'
    'content'
    'footer';
`;
export const Container = styled.div `
  /* Positioning */
  position: fixed;
  top: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndices.modal};

  /* Sizing */
  width: ${({ $width }) => getPanelWidth($width)};
  height: 100%;

  /* Responsive behavior - full-width on M and S breakpoints */
  @media (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
  }

  /* Layout */
  padding: 0;
  margin: 0;
  overflow-y: auto;

  /* Visual */
  background-color: ${({ theme }) => theme.themeVariables.frameBackgroundColor};
  transform: translateX(${(props) => (props.$isOpen ? '0' : '100%')});

  /* Interactions */
  transition: transform 0.3s ease-in-out;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;
export const Backdrop = styled(Box) `
  /* Positioning */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndices.backdrop};

  /* Visual */
  background-color: ${({ theme }) => theme.colors.fog};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};

  /* Interactions */
  transition: opacity 0.3s ease-in-out;

  /* Accessibility & Safety */
  ${({ $isOpen }) => !$isOpen &&
    `
    visibility: hidden;
    user-select: none;
  `}
`;
export const Title = styled(Box).attrs({
    as: 'h2',
    font: 'h3-semibold',
}) ``;
export const Header = styled(Box).attrs({
    as: 'header',
    padding: 6,
    gridArea: 'header',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gridColumnGap: 4,
}) `
  ${({ $isScrolled }) => $isScrolled && primaryShadow()}
  transition: box-shadow 0.2s ease-in-out;
  word-break: break-word;

  > button {
    flex-shrink: 0;
  }
`;
export const Content = styled(Box).attrs({
    as: 'main',
    flexDirection: 'column',
    gridArea: 'content',
    padding: 6,
    width: '100%',
    overflowY: 'auto',
}) `
  gap: ${({ theme }) => theme.space[5]}px;
`;
export const Footer = styled(Box).attrs({
    as: 'footer',
    padding: 6,
    gridArea: 'footer',
    position: 'sticky',
    bottom: 0,
    justifyContent: 'flex-end',
}) `
  background-color: ${({ theme }) => theme.themeVariables.frameBackgroundColor};
  gap: ${({ theme }) => theme.space[3]}px;
  ${({ $isScrolled }) => $isScrolled && primaryShadow()}
  transition: box-shadow 0.2s ease-in-out;
`;
//# sourceMappingURL=index.js.map